import router from './routes'
import store from './store'
import {Message} from 'element-ui'
// import NProgress from 'nprogress' // progress bar
// import 'nprogress/nprogress.css'// progress bar style
import {getToken} from '@/utils/auth'
import {getLoginPath} from "./utils"; // getToken from cookie

// NProgress.configure({ showSpinner: false })// NProgress Configuration

// permission judge function
// function hasPermission(roles, permissionRoles) {
//   if (roles.indexOf('admin') >= 0) return true // admin permission passed directly
//   if (!permissionRoles) return true
//   return roles.some(role => permissionRoles.indexOf(role) >= 0)
// }

const whiteList = ['/login', '/404', '/personal', '/zslogin', '/yzlogin', '/kllogin', '/hclogin']// no redirect whitelist
router.beforeEach((to, from, next) => {
    let options = router.options.routes
    let  loginPath = getLoginPath()

    // NProgress.start() // start progress bar
    if (getToken()) { // determine if there has token
        /* has token*/
        if (sessionStorage.getItem('resetPwd') === 'A') {
            let flag = true
            for (let i = 0, j = options.length; i < j; i++) {
                if (options[i].name === '系统设置') {
                    flag = false
                }
            }
            // const roles = res.data.roles // note: roles must be a array! such as: ['editor','develop']
            if (flag) {
                store.dispatch('ResetPwdONlyPersonal').then(res => { // 根据roles权限生成可访问的路由表
                    store.dispatch('GenerateRoutes', res).then(() => { // 根据roles权限生成可访问的路由表
                        router.addRoutes(store.getters.addRouters) // 动态添加可访问路由表
                        next() // hack方法 确保addRoutes已完成 ,set the replace: true so the navigation will not leave a history record
                    })
                }).catch((err) => {
                    store.dispatch('FedLogOut').then(() => {
                        Message.error(err || 'Verification failed, please login again')
                        next({path: '/login'})
                    })
                })
            }

        } else {
            if (to.path === '/zslogin' || to.path === '/yzlogin' || to.path === '/kllogin' || to.path === '/hclogin') {
                next()
                // NProgress.done() // if current page is dashboard will not trigger	afterEach hook, so manually handle it
            } else {
                if (store.getters.addRouters.length === 0) {
                    store.dispatch('GetUserAccess').then(res => { // 拉取user_info
                        // const roles = res.data.roles // note: roles must be a array! such as: ['editor','develop']
                        store.dispatch('GenerateRoutes', res).then(() => { // 根据roles权限生成可访问的路由表
                            router.addRoutes(store.getters.addRouters) // 动态添加可访问路由表
                            next({...to, replace: true}) // hack方法 确保addRoutes已完成 ,set the replace: true so the navigation will not leave a history record
                        })
                    }).catch((err) => {
                        store.dispatch('FedLogOut').then(() => {
                            Message.error(err || 'Verification failed, please login again')
                            next({path: '/'})
                        })
                    })
                } else {
                    next()
                }
            }
        }
    } else {
        /* has no token*/
        if (whiteList.indexOf(to.path) !== -1) { // 在免登录白名单，直接进入
            next()
        } else {
            next(loginPath) // 否则全部重定向到登录页
            // NProgress.done() // if current page is login will not trigger afterEach hook, so manually handle it
        }
    }
})




// WEBPACK FOOTER //
// ./src/permission.js